(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .factory('requestDemoService', requestDemoService);

  /* ngInject */
  function requestDemoService($resource, config) {
    let url = `${config.complianceFrameworkApiEndpoint}/api/request_demo`;
    let paramDefaults = {};
    let headers = authToken => ({'Authorization': 'Token token=' + authToken});
    let actions = authToken => ({
      'save': {
        method: 'POST',
        headers: headers(authToken)
      }
    });

    return authToken => $resource(url, paramDefaults, actions(authToken));
  }
})();
